import {REMOVE_AUTH, SET_AUTH, SET_WARE_CODE} from "./types";

const mutations = {
    [SET_AUTH]: (state, authInfo) => {
        state.authInfo = authInfo
        window.sessionStorage.removeItem('authInfo')
        window.sessionStorage.setItem('authInfo', JSON.stringify(authInfo)) // authInfo Object
        // console.log(state.token)
    },
    [SET_WARE_CODE]: (state, wareCode) => {
        console.log(state, wareCode)
        state.wareCode = wareCode
        window.sessionStorage.removeItem('wareCode')
        window.sessionStorage.setItem('wareCode', wareCode) // authInfo Object
        // console.log(state.token)
    },
    [REMOVE_AUTH]: (state) => {
        window.sessionStorage.removeItem('authInfo') // authInfo Object
        window.sessionStorage.removeItem('wareCode')
        window.sessionStorage.removeItem('wareType')
        state.authInfo = {}
        state.wareCode = ''
    }
}
export default mutations